import Vue from 'vue'
import Snotify from 'vue-snotify'
import 'vue-snotify/styles/material.scss'

const options = {
  toast: {
    maxOnScreen: 4,
    showProgressBar: false,
    timeout: 10000
  }
}

Vue.use(Snotify, options)
